export default __webpack_public_path__ + "static/media/tmp.212ec7a5.jpg";